function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".AddPredicateSelected-1{fill:none;stroke:#ffbe54;stroke-miterlimit:3.3;stroke-width:1.62px;}.AddPredicateSelected-2{fill:#ffbe54;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "g6158"
}, /*#__PURE__*/React.createElement("rect", {
  id: "rect5254-8",
  className: "AddPredicateSelected-1",
  x: 0.81,
  y: 0.81,
  width: 33.2,
  height: 33.22,
  rx: 4.12
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect5256-7",
  className: "AddPredicateSelected-2",
  x: 3.08,
  y: 18.18,
  width: 13.59,
  height: 13.59,
  rx: 3.01
}), /*#__PURE__*/React.createElement("rect", {
  id: "rect5264-7",
  className: "AddPredicateSelected-2",
  x: 18.18,
  y: 3.08,
  width: 13.59,
  height: 13.59,
  rx: 3.01
}));

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  className: "AddPredicateSelected-2",
  points: "25.06 23.13 25.06 19.13 23.06 19.13 23.06 23.13 19.06 23.13 19.06 25.13 23.06 25.13 23.06 29.13 25.06 29.13 25.06 25.13 29.06 25.13 29.06 23.13 25.06 23.13"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  className: "AddPredicateSelected-1",
  cx: 24.06,
  cy: 24.13,
  r: 8
});

var SvgAddPredicateSelected = function SvgAddPredicateSelected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "AddPredicateSelected",
    viewBox: "0 0 34.82 34.84",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddPredicateSelected, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AddPredicateSelected.d1e67e7c.svg";
export { ForwardRef as ReactComponent };